
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1dNQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $95b4cdaa4ace2b66$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $95b4cdaa4ace2b66$var$AsyncTeamProfileCardNext = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("fSQlT")), {
    ssr: false,
    moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95b4cdaa4ace2b66$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.profilecard-next.team-profilecard",
        packageName: "async.profilecard-next.team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-team-profilecard-next",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95b4cdaa4ace2b66$var$AsyncTeamProfileCardNext, props)));

});
parcelRegister("fSQlT", function(module, exports) {

let $b90482383886b7d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b90482383886b7d8$var$load("cM9em"),
    $b90482383886b7d8$var$load("fr9NE"),
    $b90482383886b7d8$var$load("2MFVe")
]).then(()=>parcelRequire('3FCPe'));

});



//# sourceMappingURL=async.74945d42.js.map
